import { useCallback } from 'react';
import { routes } from 'routes/routes';

export const useGenerateInvitationLink = () =>
  useCallback(
    ({ communityId, token }: { communityId: string; token: string }) =>
      `${window.location.origin}${routes.community.shareInvite(communityId, token)}`,
    [],
  );
